import { mobileSlider } from './scripts'
import jQuery from 'jquery';

(function () {

  window.addEventListener("DOMContentLoaded", function () {
    const slides = document.querySelectorAll('.winners-archive-slider');
    for (let i = 0; i < slides.length; i++) {
      let count = jQuery('.winners-archive-slider-' + i).data('count')
      if (count > 1) {
        mobileSlider(".winners-archive .winners-archive-slider-" + i, ".swiper-pagination--winners-archive-" + i);
      }
    }
  });
})();